import { Link } from 'react-router-dom';
import LessonJournal from '../components/LessonJournal';

/**
 * Журнал занятий ученика: список LessonSession с отчётом и своими заметками.
 */
export default function MyLessonsPage() {
  return (
    <div className="my-lessons-page">
      <div className="page-header">
        <h1>Журнал занятий</h1>
        <p className="page-subtitle">
          Занятия с преподавателем: дата, краткий отчёт по задачам и комментарии.
          История отдельных попыток — в разделе{' '}
          <Link to="/my-attempts">Мои попытки</Link>.
        </p>
      </div>
      <LessonJournal mode="student" />
    </div>
  );
}
